export const NEW_TICKET = 'temp-' as const;

export function isNewTicket(id: string) {
  return id.startsWith(NEW_TICKET);
}
